import type React from 'react';

import Icon from '@cobliteam/ui/icons';

import Button from '@cobliteam/ui/components/Button';
import DropdownMenu from '@cobliteam/ui/components/DropdownMenu';

export interface DataTableActionsProps {
  children: React.ReactNode;
  dataTour?: string; // Use to add data-tour attribute to the trigger button
  modal?: boolean;
}

const DataTableActions = ({ children, dataTour, modal }: DataTableActionsProps) => {
  return (
    <div className='flex justify-center'>
      <DropdownMenu modal={modal}>
        <DropdownMenu.Trigger asChild data-tour={dataTour}>
          <Button variant='outlined' color='default' size='condensed' icon={<Icon name='ellipsis' />} data-testid='data-table-actions' />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align='end'>{children}</DropdownMenu.Content>
      </DropdownMenu>
    </div>
  );
};

export default DataTableActions;
